import React, { Component } from 'react';
import {auth, firebase} from '../firebase';
import moment from 'moment'
import ModalConnection from './ModalConnectionSubscribe';
import {doSignOut} from '../authDB';










class App extends Component {
    constructor(){
        super();
        this.state = {orders : {}};
     
      }
    componentDidMount(){
        let uid = JSON.parse(localStorage.getItem('user')).uid;
        var ref= firebase.database().ref(`/users_orders/${uid}/`);
        ref.orderByChild('created_at')
        .on('child_added',(data)=>{
         // console.log(data.val())
    if(data.val())
          this.setState((prev)=>{
            return{orders:{[data.key]:data.val(),...prev.orders}}
          })
        })
    
      }
      show_connection(){
        this.refs.ModalConnection.handleShow();
    console.log(this.refs)
    }
    Deconx(){
      localStorage.removeItem('user')
      doSignOut().then(()=>{
        window.parent.location = window.parent.location.href;
    
      })
    }
      order_list(){
        var items=[]
        var orders =this.state.orders
        Object.keys(orders||[]).forEach((v,e)=>{
          items.push(
            <section  style={{marginLeft:"20%",marginRight:"20%",boxShadow:" 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)"}}>
            <div style={{marginLeft:30 ,marginRight:30}} className="row">
            
              <p>
             <span >   <div style={{marginTop:30}}>{moment(orders[v].created_at).format('LLL')}</div> </span> 
               <br/>
               <span  >  Prix total</span> <span style={{float:'right'}} >  {orders[v].total_price.toFixed(3)} TND</span> 
            
              </p>
            {/*<button class="btn" style={{color:"#ffffff",backgroundColor:"orange",float:'right'}}>suivre la commande </button> 
          */}  </div>
            
            <hr/>
          </section>  
          
          )
        })
        return items
      }
  render() {
      console.log(this.state)
    return (
   <div>
         <header className="header">
            <div className="container">
                <div className="menubar">
                    <div className="row">
                        <div className="col-md-12">
                            <nav className="navbar navbar-static-top">
                             <div className="navbar-header">
                                    <button type="button" className="navbar-toggle collapsed" data-toggle="collapse" aria-expanded="false">
                                        <span className="sr-only">Toggle navigation</span>
                                        <span className="icon-bar"></span>
                                        <span className="icon-bar"></span>
                                        <span className="icon-bar"></span>
                                    </button>
                                    <a className="navbar-brand" href="/">
                                        <img src="/images/logo.png" className="img-responsive" alt="logo"/>
                                    </a>
                                </div>                      
     <div className="collapse navbar-collapse ">
                                    <ul className="nav navbar-nav navbar-right">
                                    
                                    <li className="res-btn">
                                          {(JSON.parse(localStorage.getItem('user')))?  <button onClick={()=>this.Deconx()} className="book-btn">Déconnection</button>:<button onClick={()=>this.show_connection()} className="book-btn">Connexion</button>}
                                    </li>
                                    </ul>
                                    <ul className="nav navbar-nav navbar-right" id="main-menu">

                                    <li className="">

                                         <a  href="/">
                                                Accueil
                                         </a>
                                    </li>
                                         {/*    <li className="">
                                            <a  href="/about">À propos</a>
    </li>*/}
                                        <li className="">
                                            <a  href="/order">Menu</a>                                          
                                        </li>
                                        {(JSON.parse(localStorage.getItem('user')))?  <li className="">
                                            <a  href="/historique">Historique</a>
                                        </li>:null       }     
                                        {(JSON.parse(localStorage.getItem('user')))?   <li className="">
                                            <a href="/loyalty">
                                            Fidélité
                                            </a>
                                        </li>  :null       } 
                                        <li className="">
                                            <a   href="/Blog">
                                                Blog
                                            </a>
                                        </li>     
                                                          
                                        <li className="">
                                            <a   href="/contact">
                                                Contact
                                            </a>
                                        </li>  
                                                                           
                                    </ul>
                                </div>  
                            </nav>
                        </div>
                    </div>
                </div>

            </div>
            <div className="mobile-menu" data-logo="/images/logo.png">


            </div>



        </header>
       
        <section className="page-title">
    <div className="container">
        <h2 className="title">
           Historique des Commandes
        </h2>
        <ul className="brdcrumb clearfix">
            <li>
                <a href="index.html">Accueil</a>
            </li>
           
            <li className="current">
                Historique
            </li>
        </ul>
    </div>
</section>
<section className="contact-section section-padding">
{this. order_list()}
</section>


   
   <ModalConnection ref="ModalConnection"/>

    </div>


   
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/container/historique.js